export const DIFFICULTIES = ["easy", "medium", "hard"];
export const DIFF_LABEL = { easy: "Easy", medium: "Medium", hard: "Hard" };
export const DIFF_COLOR = { easy: "#22C55E", medium: "#F59E0B", hard: "#EF4444" };
export const DIFF_DESC = {
  easy: "Slower pace, common words, extra lives.",
  medium: "The standard challenge.",
  hard: "Fast, long words, fewer lives. No mercy.",
};
